import type { UnifiedGroup } from '../../../shared';
import { getInitials } from '@fluentui/utilities/lib/initials';
import type { UnifiedGroupSorting } from '../../models/unifiedGroupListViewState';

// Todo: This is a naive approach and does not take language specific rules into consideration
export function initial(
    group: UnifiedGroup,
    sorting: UnifiedGroupSorting,
    emptyMarker: string
): string {
    let name: string;
    name = group.displayName; // For PDLs, there is no first-last or last-first difference

    const initials = getInitials(name, false);
    const initial = initials && initials.length > 0 ? initials[0] : emptyMarker;

    // If the initial is a number, show #
    return /^\d+$/.test(initial) ? '#' : initial;
}
